"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = require("react");
var styles_module_scss_1 = __importDefault(require("./Roulette/styles.module.scss"));
var ANIMATION_TIME = 6000;
var MAX_ROLL_COUNT = 8; // how many laps need to spin wheel
var CIRCLE = 360;
var useAnimation = function () {
    var animateRoulette = function (_a) {
        var prizes = _a.prizes;
        var prizesContainer = document.querySelector('.wheelFortunePrizes');
        var lights = document.querySelectorAll('.lightRoulette');
        var prizeIndex = prizes.findIndex(function (prize) { return prize.active; });
        var halfSectionDegree = 360 / prizes.length / 2 - 5;
        // plus or minus * random * half section
        var randomCoefficientForRotate = (Math.random() < 0.5 ? -1 : 1) * Math.random() * halfSectionDegree;
        var prizeStopDegree = prizes[prizeIndex].degree + randomCoefficientForRotate;
        // stop degree need to be less 360 for stop roulette
        if (prizeStopDegree > 360) {
            prizeStopDegree =
                prizes[prizeIndex].degree - Math.random() * halfSectionDegree;
        }
        prizesContainer.childNodes.forEach(function (n) {
            return n.classList.remove(styles_module_scss_1.default.active);
        });
        return new Promise(function (resolve) {
            var currentSpeed = 0;
            var isRouletteStop;
            var stopRoulette = CIRCLE * MAX_ROLL_COUNT + prizeStopDegree;
            var lightCounter = 1;
            function animateLights() {
                var timeOutMS = 50 - Math.pow(currentSpeed, 2) > 0
                    ? 50 - Math.pow(currentSpeed, 2)
                    : 0;
                var timeoutId = setTimeout(function () {
                    var itemIdx = lightCounter < lights.length
                        ? lightCounter
                        : (lightCounter % lights.length).toFixed();
                    var currentElement = lights[itemIdx];
                    var styleElement = function (element, opacity) {
                        if (opacity === void 0) { opacity = '0.4'; }
                        element.style.opacity === '1' || !element.style.opacity
                            ? (element.style.opacity = opacity)
                            : (element.style.opacity = '1');
                    };
                    var prevIndex = Number(itemIdx) - 1 > 0 ? Number(itemIdx) - 1 : lights.length - 1;
                    var nextIndex = Number(itemIdx) + 1 < lights.length - 1 ? Number(itemIdx) + 1 : 0;
                    styleElement(lights[prevIndex], '0.6');
                    styleElement(currentElement);
                    styleElement(lights[nextIndex], '0.6');
                    lightCounter++;
                    if (!isRouletteStop)
                        animateLights();
                    else {
                        // @ts-ignore
                        for (var _i = 0, lights_1 = lights; _i < lights_1.length; _i++) {
                            var light = lights_1[_i];
                            ;
                            light.style.opacity = '1';
                        }
                    }
                    clearTimeout(timeoutId);
                }, timeOutMS);
            }
            animateLights();
            var animation;
            var previousEndDegree = 0;
            if (animation) {
                animation.cancel(); // Reset the animation if it already exists
            }
            var newEndDegree = previousEndDegree + stopRoulette;
            animation = prizesContainer.animate([
                { transform: "rotate(".concat(previousEndDegree, "deg)") },
                { transform: "rotate(".concat(newEndDegree, "deg)") },
            ], {
                duration: ANIMATION_TIME,
                direction: 'normal',
                easing: 'cubic-bezier(0.3, -0.2, 0, 1)',
                fill: 'forwards',
                iterations: 1,
            });
            var timer = setTimeout(function () {
                resolve(true);
                isRouletteStop = true;
                var activeSector = prizesContainer.childNodes[prizeIndex];
                activeSector.classList.add(styles_module_scss_1.default.active);
                clearTimeout(timer);
            }, ANIMATION_TIME + 500);
            previousEndDegree = newEndDegree;
        });
    };
    return (0, react_1.useMemo)(function () { return ({ animateRoulette: animateRoulette }); }, []);
};
exports.default = useAnimation;
